export default function BottomBar() {
  return (
    <div className="fixed bottom-0 left-0 right-0 z-40 bg-white/95 backdrop-blur-md border-t border-background-200/70 shadow-lg shadow-black/5 md:hidden">
      <div className="w-full px-4 py-3">
        <div className="flex items-center gap-3">
          <a
            href="tel:+15551234567"
            className="w-11 h-11 flex items-center justify-center rounded-full bg-background-100 border border-background-200/70 text-foreground-700 hover:text-primary-500 hover:border-primary-300 transition-colors cursor-pointer flex-shrink-0"
            aria-label="Call CareBridge"
          >
            <i className="ri-phone-line text-lg"></i>
          </a>
          <a
            href="mailto:family1st@carebridge.club"
            className="w-11 h-11 flex items-center justify-center rounded-full bg-background-100 border border-background-200/70 text-foreground-700 hover:text-primary-500 hover:border-primary-300 transition-colors cursor-pointer flex-shrink-0"
            aria-label="Email CareBridge at family1st@carebridge.club"
          >
            <i className="ri-mail-line text-lg"></i>
          </a>
          <a
            href="https://carebridge4elderly.base44.app"
            target="_blank"
            rel="nofollow noopener noreferrer"
            className="flex-1 bg-primary-500 text-white font-semibold px-5 py-3 rounded-full hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap text-center inline-block"
          >
            <span className="flex items-center justify-center gap-2">
              Get the App
              <i className="ri-arrow-right-line text-sm"></i>
            </span>
          </a>
        </div>
      </div>
    </div>
  );
}